import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	getContacts: {
		total: 0,
		results: [],
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	},
	createContact: {
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	}
};

export const contactsSlice = createSlice({
	name: 'contacts',
	initialState,
	reducers: {
		createContact: (state) => {
			state.createContact.isLoading = true;
		},
		createContactCompleted: (state) => {
			state.createContact.isLoading = false;
			state.createContact.hasBeenLoaded = true;
			state.createContact.error = '';
		},

		createContactFailed: (state, action) => {
			state.createContact.isLoading = false;
			state.createContact.hasBeenLoaded = false;
			state.createContact.error = action.payload;
		},
		getContacts: (state) => {
			state.getContacts.isLoading = true;
		},
		getContactsCompleted: (state, action) => {
			state.getContacts.results = action.payload.results;
			state.getContacts.total = action.payload.total;
			state.getContacts.isLoading = false;
			state.getContacts.hasBeenLoaded = true;
			state.getContacts.error = '';
		},

		getContactsFailed: (state, action) => {
			state.getContacts.contacts = [];
			state.getContacts.isLoading = false;
			state.getContacts.hasBeenLoaded = false;
			state.getContacts.error = action.payload;
		}
	}
});

export const {
	createContact,
	createContactCompleted,
	createContactFailed,
	getContacts,
	getContactsCompleted,
	getContactsFailed
} = contactsSlice.actions;

export default contactsSlice.reducer;
